import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-nested-list-content',
  templateUrl: './nested-list-content.component.html',
  styleUrls: ['./nested-list-content.component.sass']
})
export class NestedListContentComponent {
  @Input() field: any;
  @Input() record: any;

  getNestedValue(obj: any, path: string): any {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
  }

  isObject(value: any): boolean {
    return typeof value === 'object' && !Array.isArray(value) && value !== null;
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  camelCaseToWords(key: string): string {
    return key
      .replace(/([A-Z])/g, ' $1') // Insert a space before each capital letter
      .replace(/^./, (str) => str.toUpperCase()); // Capitalize the first letter
  }
}